import { DatePipe, NgClass, NgStyle } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BASE_IMAGE_URL, PAGELENGTH } from 'src/app/endpoints';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { CompanyService } from 'src/app/shared/service/company/company.service';
import { SampleService } from 'src/app/shared/service/sample/sample.service';
import { UserDataService } from 'src/app/shared/service/userData/user-data.service';
import { UserServiceService } from 'src/app/shared/service/userService/user-service.service';
import Swal from 'sweetalert2';
declare var bootstrap: any;

@Component({
  selector: 'app-all-distributors',
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    MatIcon,
    ReactiveFormsModule,
    DatePipe,
    NgSelectModule,
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatLabel,
    MatInputModule,
    RouterLink,
    NgStyle,
    NgClass


  ],
  templateUrl: './all-distributors.component.html',
  styleUrl: './all-distributors.component.scss'
})
export class AllDistributorsComponent {
  pageSize: any
  formType: string = 'Add';
  registerModal: any;
  sampleModal: any;
  startpoint: number;
  search: any;
  totalLoaded: number;
  total: any;
  pageNo: any;
  companyRes: any
  wholeSalerId: any
  states: any
  cities: any
  _id: any
  companyId: any



  constructor(
    private companyService: CompanyService,
    private sampleService: SampleService,
    private userService: UserServiceService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public userDataService: UserDataService,
  ) {
    this.setDisplayedColumns();
  }
  filter: any = {
    name: '',
    cityState: '',
    companyId: null,
  };


  isCompanyLoggedIn: boolean = false

  getCompanyData() {
    let userData = this.userDataService.getData()
    let companyData = userData.company
    if (!!companyData) {
      this.isCompanyLoggedIn = true
      this.filter.companyId = companyData._id
      this.companyId = companyData._id
      this.getAllDistributors(null)
    }
    else {
      this.isCompanyLoggedIn = false
      this.getAllDistributors(null);
    }
  }


  ngOnInit(): void {
    this.getCompanyData()
    this.getCities()
    this.getStates()
    this.allCompaniesMini()
  }


  distributors: any[] = [];
  selectedDistributor: any;


  getCities() {
    this.sampleService.getCities({}).subscribe({
      next: (result) => {
        if (result.success) {
          this.cities = result.data
        }
      },
      error: (e) => {
        this.toastr.error(e)
      }
    })
  }
  getStates() {
    this.sampleService.getStates({}).subscribe({
      next: (result) => {
        if (result.success) {
          this.states = result.data
        }
      },
      error: (e) => {
        this.toastr.error(e)
      }
    })
  }

  getImg(imgPath: any) {
    return BASE_IMAGE_URL + imgPath
  }

  displayedColumns: string[] = [];

  setDisplayedColumns(): void {
    this.displayedColumns = [
      'position', 'name', 'contact', 'gst', 'cordinates', 'address', 'createdAt', 'preview', 'samples'
    ];
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('fileInput') fileInput: ElementRef;

  ngAfterViewInit() {

    const modalElement = document.getElementById('registerModal');
    if (modalElement) {
      this.registerModal = new bootstrap.Modal(modalElement);
    }
    const sampleModallElement = document.getElementById('sampleModal');
    if (sampleModallElement) {
      this.sampleModal = new bootstrap.Modal(sampleModallElement);
    }

  }
  dataSource = new MatTableDataSource<any>([]);

  debounceNameTimer: any = null;
  debounceCityStateTimer: any = null;


  allCompanies: any[] = [];


  companyFilter(event: any): void {
    this.getAllDistributors(null);
  }


  allCompaniesMini() {
    this.companyService.allCompaniesMini({}).subscribe({
      next: (result) => {
        if (result.success) this.allCompanies = result.data;
      },
      error: (e) => this.toastr.error(e)
    });
  }

  onNameInputChange(event: any): void {
    clearTimeout(this.debounceNameTimer);
    this.debounceNameTimer = setTimeout(() => {
      const name = event.target.value.trim();
      this.filter.name = name || undefined;
      this.getAllDistributors(null);
    }, 500);
  }


  onCityStateChange(event: any): void {
    clearTimeout(this.debounceCityStateTimer);
    this.debounceCityStateTimer = setTimeout(() => {
      const cityState = event.target.value.trim();
      this.filter.cityState = cityState || undefined;
      this.getAllDistributors(null);
    }, 500);

  }

  getAllDistributors(event: any) {
    this.spinner.show();

    if (!event) {
      this.pageNo = 0;
      this.startpoint = 0;
      this.pageSize = this.pageSize || 10;
      this.dataSource.data = [];
    }

    if (event?.pageSize && event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
      this.pageNo = 0;
      this.startpoint = 0;
      this.dataSource.data = [];
    }

    if (event?.pageIndex !== undefined) {
      this.pageNo = event.pageIndex;
      this.startpoint = this.pageNo * (this.pageSize || 10);
    }

    const data: any = {
      startpoint: this.startpoint,
      limit: this.pageSize,
      search: this.search || undefined,
      nameEmail: this.filter?.name || undefined,
      cityState: this.filter?.cityState || undefined,
      companyId: this.filter?.companyId || undefined
    };

    this.userService.allDistributor(data).subscribe({
      next: (result) => {
        if (result?.success) {
          this.total = result.total ?? 0;
          this.dataSource.data = result.data || [];

          setTimeout(() => {
            if (this.paginator) {
              this.paginator.pageIndex = this.pageNo;
              this.paginator.length = this.total;
              this.paginator.pageSize = this.pageSize;
            }
          }, 0);
        }
      },
      error: (error: any) => {
        let errorMsg = "An unexpected error occurred.";
        if (error.status === 0) {
          errorMsg = "Server not reachable. Please check your network connection.";
        } else if (error.error?.message) {
          errorMsg = error.error.message;
        } else if (error.message) {
          errorMsg = error.message;
        }
        this.toastr.error(errorMsg, "Error");
        console.error("Distributor Fetch Error:", error);
      },
      complete: () => this.spinner.hide()
    });
  }






  disId: any

  changeType(type: any) {
    this.selectedType = type
    this.companyDistributor()
  }

  distributorPreview: any[] = []

  selectedType: number | null = null;


  companyDistributor() {
    const payload: any = { distributorId: this.disId };
    if (this.selectedType) {
      payload.distributorType = this.selectedType;
    }
    this.userService.allCompanyDistributor(payload).subscribe({
      next: (result) => {
        if (result.success) {
          this.distributorPreview = result.data;
        }
      },
      error: (e) => this.toastr.error(e)
    });

  }

  dData: any
  singleDis() {
    this.userService.singleDistributor({ _id: this.disId }).subscribe({
      next: (result) => {
        if (result.success) {
          this.dData = result.data;
        }
      },
      error: (e) => this.toastr.error(e)
    });
  }


  openModel(disId: any) {
    this.disId = disId
    this.singleDis()
    this.companyDistributor()
    this.registerModal.show();
  }


  hideModel() {
    this.selectedType = undefined
    this.registerModal.hide();

  }







}
